import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Page} from '../../../types/enums/page.enum';

export type PageSlice = {
  value: Page;
  navigatedFromSkip: boolean;
};

const initialState: PageSlice = {
  value: Page.POLL,
  navigatedFromSkip: false,
};

const pageSlice = createSlice({
  name: 'pageSlice',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Page>) => {
      state.value = action.payload;
      state.navigatedFromSkip = false;
    },

    setFromSkip: (state, action: PayloadAction<Page>) => {
      state.value = action.payload;
      state.navigatedFromSkip = true;
    },

    clearSkipFlag: (state) => {
      state.navigatedFromSkip = false;
    },

    reset: () => initialState,
  },
});

export const {set, setFromSkip, clearSkipFlag, reset} = pageSlice.actions;
export default pageSlice.reducer;
